import { DatePicker, Select } from "antd";
import React, { useEffect, useState } from "react";

import { Link, useLocation } from "react-router-dom";

import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { Tabs } from "antd";

import BillTo from "./BillTo";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import dayjs from "dayjs";
import ProductTable from "../../../../../core/pagination/ProductTable";

const CreateNewEstimate = () => {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const navigate = useNavigate();

  const { state } = useLocation();

  console.log(state, "state................................");

  console.log("Customer ID:", state?.customerId);

  const customermainid = state?.customerId;
  console.log(customermainid);

  const [countries, setCountries] = useState([]);
  const [countryLoading, setCountryLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [isCustomerPrefilled, setIsCustomerPrefilled] = useState(false);

  const [isPrefilled, setIsPrefilled] = useState(false);

  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs().add(15, "day"));

  const [saving, setSaving] = useState(false);

  const prefillStyle = isPrefilled
    ? {
        backgroundColor: "#fff8db",
        border: "1px solid #fff8db",
      }
    : {};

  const [formData, setFormData] = useState({
    adminnote: "",
    clientnote: "",
    terms:
      "1) Warranty: 12 months from the date of installation. The materials are not covered if they fail due to power fluctuation, accidents, or physical damages. 2) Devices once installed or used will not be taken back (No Refund).",
   
    reference_no: "",
    street: "",
    city: "",
    state: "",
    zip: "",
    country: null,

    project_id: null,
    adjustment: 0,
    currency: null,
  });

  useEffect(() => {
    if (!state) return;

    if (state.type === "customer") {
      const customer = state.record;

      setSelectedCustomer({
        value: customer.customerId,
        label: customer.company,
      });
      if (state.type === "customer") {
        fillCustomerDetails(state.record);
        setIsCustomerPrefilled(true);
      }
    }
  }, [state, countries]);

  const fillCustomerDetails = (customer) => {
    console.log("Customer Data.........:", customer);
    setFormData((prev) => ({
      ...prev,
      street: customer.address || "",
      city: customer.billing_city || "",
      state: customer.billing_state || "",
      zip: customer.billing_zip || "",
      country: customer.billing_country || null,
      currency: customer.default_currency,
    }));

    setCurrencyId(customer.default_currency);

    setIsPrefilled(true);

    setSelectedCountry(
      countries.find((c) => c.value === customer.billing_country) || null
    );

    setIsCustomerPrefilled(true);

    setSelectedCustomer({
      value: customer.customerId,
      label: customer.company,
    });
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    }
  };

  const getCustomerDetails = async (customerId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length > 0) {
        fillCustomerDetails(data.ResultData[0]);
        setIsCustomerPrefilled(true);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getCountries = async () => {
    try {
      setCountryLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetCountries`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.country_id,
          label: item.short_name,
        }));

        setCountries(options);

        // Optional: Set India as default if available
        const india = options.find((item) => item.label === "India");

        if (india) {
          setSelectedCountry(india.value);
        } else if (options.length > 0) {
          setSelectedCountry(options[0].value);
        }
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setCountryLoading(false);
    }
  };

  useEffect(() => {
    getCountries();

    getCustomers();
  }, []);

  const [currencyId, setCurrencyId] = useState(formData.currency);

  const [productData, setProductData] = useState({
    items: [],
    subtotal: 0,
    discount: 0,
    discountAmount: 0,
    discountType: "before",
    taxes: [],
    totalTax: 0,
    adjustment: 0,
    total: 0,
    currencyId: null,
  });

  const addEstimates = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        clientid: selectedCustomer?.value,

        project_id: 0,

        number: 0,
        prefix: "EST-",

        date: startDate ? startDate.format("YYYY-MM-DD") : null,

        expirydate: endDate ? endDate.format("YYYY-MM-DD") : null,

        currency: productData?.currencyId || 5,

        subtotal: Number(productData?.subtotal || 0),

        total_tax: Number(productData?.totalTax || 0),

        total: Number(productData?.total || 0),

        adjustment: Number(productData?.adjustment || 0),

        addedfrom: userId,

        status: 1,

        clientnote: formData.clientnote || "",

        adminnote: formData.adminnote || "",

        discount_percent: Number(productData?.discount || 0),

        discount_total: Number(productData?.discountAmount || 0),

        discount_type: productData?.discountType || "",

        terms: formData.terms || "",

        reference_no: formData.reference_no || "",

        sale_agent: userId,

        billing_street: formData.street || "",
        billing_city: formData.city || "",
        billing_state: formData.state || "",
        billing_zip: formData.zip || "",
        billing_country: selectedCountry?.value || 0,

        shipping_street: "",
        shipping_city: "",
        shipping_state: "",
        shipping_zip: "",
        shipping_country: selectedCountry?.value || 0,

        include_shipping: 0,

        show_shipping_on_credit_note: 0,

        show_quantity_as: 1,

        items: (productData?.items || []).map((item) => ({
          item_id: item.productId || item.id,
        
          description: item.item || "",
        
          long_description: item.description || "",
        
          qty: Number(item.qty || 0),
        
          rate: Number(item.rate || 0),
        
          unit: item.unit || "",
        
          item_taxes: Array.isArray(item.taxes)
            ? item.taxes.map((tax) => ({
              taxrate: Number(tax.taxrate || 0),
              taxname: tax.label || "",
              }))
            : [],
        })),
      };

      console.log("Payload:", payload);

      const response = await axios.post(
        `${BASE_CRM_URL}estimates/AddEstimate`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("After API", response);

      if (response.data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data.Message,
          confirmButtonColor: "#3085d6",
        }).then(() => {
          if (state?.type === "customer") {
            navigate(`/crm/customerinfo/${customermainid}`);
            return;
          }

        console.log(response.data);
        navigate("/crm/estimates");
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.Message,
          confirmButtonColor: "#d33",
        });
      }
    } catch (error) {
      console.error(error);

      console.error(
        error.response?.data?.Message || "Failed to add Estimates."
      );
    } finally {
      setSaving(false);
    }
  };

  const tabItems = [
    {
      key: "1",
      label: (
        <>
          <i className="bi bi-person-lines-fill me-2"></i>
          Customer
        </>
      ),
      children: (
        <>
          <div className="row">
            <div className="mb-2 col-3">
              <label>Customer</label>
              <Select
                showSearch
                placeholder="Select Customer"
                optionFilterProp="label"
                className={`w-100 ${
                  isCustomerPrefilled ? "prefilled-select" : ""
                }`}
                style={{ height: 38 }}
                options={customerOptions}
                value={selectedCustomer}
                onChange={(value) => {
                  setSelectedCustomer(value);
                  getCustomerDetails(value);
                }}
              />
            </div>

            <div className="mb-3 col-3">
              <label>Estimated Date</label>
              <DatePicker
                value={startDate}
                format="DD-MM-YYYY"
                style={prefillStyle}
                className="w-100"
                onChange={(date) => {
                  setStartDate(date);

                  if (date) {
                    setEndDate(date.add(15, "day"));
                  } else {
                    setEndDate(null);
                  }
                }}
              />
            </div>

            <div className="mb-3 col-3">
              <label>Expiry Date</label>

              <DatePicker
                value={endDate}
                format="DD-MM-YYYY"
                style={prefillStyle}
                className="w-100"
                onChange={(date) => setEndDate(date)}
              />
            </div>
            <div className="mb-2 col-3">
              <label> (Bill To) Street</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Street"
                value={formData.street}
                onChange={(e) =>
                  setFormData({ ...formData, street: e.target.value })
                }
                style={{
                  backgroundColor: selectedCustomer ? "#fff8db" : "#fff",
                }}
              />
            </div>

            <div className="mb-2 col-3">
              <label>City</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter City"
                value={formData.city}
                onChange={(e) =>
                  setFormData({ ...formData, city: e.target.value })
                }
                style={{
                  backgroundColor: selectedCustomer ? "#fff8db" : "#fff",
                }}
              />
            </div>

            <div className="mb-2 col-3">
              <label>State</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter State"
                value={formData.state}
                onChange={(e) =>
                  setFormData({ ...formData, state: e.target.value })
                }
                style={{
                  backgroundColor: selectedCustomer ? "#fff8db" : "#fff",
                }}
              />
            </div>

            <div className="mb-2 col-3">
              <label>Zip Code</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Zip Code"
                value={formData.zip}
                onChange={(e) =>
                  setFormData({ ...formData, zip: e.target.value })
                }
                style={{
                  backgroundColor: selectedCustomer ? "#fff8db" : "#fff",
                }}
              />
            </div>

            <div className="mb-2 col-3">
              <label>Country</label>
              <Select
                style={{ height: 38 }}
                className={`w-100 ${
                  isCustomerPrefilled ? "prefilled-select" : ""
                }`}
                placeholder="Select Country"
                options={countries}
                value={selectedCountry}
                loading={countryLoading}
                onChange={(value) => {
                  setSelectedCountry(value);
                  setIsCustomerPrefilled(false);
                }}
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </div>

          
            <div className="mb-2 col-3">
              <label>Reference #</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Reference #"
                value={formData.reference_no || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    reference_no: e.target.value,
                  }))
                }
                required
              />
            </div>

          
            <div className="mb-2 col-9">
              <label>Admin Note</label>
              <textarea
                className="form-control"
                placeholder="Enter text here"
                rows="1"
                value={formData.adminnote}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    adminnote: e.target.value,
                  }))
                }
              />
            </div>
          </div>
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <i className="bi bi-cart3 me-2"></i>
          Items & Totals
        </>
      ),
      children: (
        <>
          <ProductTable
            currencyId={currencyId}
            initialItems={productData.items}
            onProductDataChange={setProductData}
          />
        </>
      ),
    },
  ];

  
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item">
            <div className="d-flex flex-column">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    New Estimate
                  </h4>
                </ol>
              </nav>
              <p className="text-muted">Create a New Estimate here</p>
            </div>
          </div>
          <div className="page-btn d-flex jusitfy-content-between">
            <Link
              to="/crm/estimates"
              className="btn btn-secondary btn-sm d-flex align-items-center"
            >
              <i className="ti ti-arrow-left fs-4 "> </i>
            </Link>
          </div>
        </div>

        <div className="card">
          <div className="card-header ">
            <h4 className="text-primary">
              {/* {formData.proposal_to} */}
              Balaji Finance
            </h4>
          </div>
          <div className="card-body ">
            <form onSubmit={addEstimates}>
              <Tabs
                defaultActiveKey="1"
                items={tabItems}
                size="large"
                tabBarGutter={30}
                animated
              />

              <div className="d-flex justify-content-end mt-2">
                <button type="submit" className="btn btn-info me-2">
                  Save & Send
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={saving}
                >
                  {saving ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save"
                  )}
                
                </button>
              </div>
            </form>
          </div>
        </div>
        <CommonFooter />
      </div>
      <>
        <BillTo />
      </>
    </div>
  );
};

export default CreateNewEstimate;
